import { SearchAndFilterTypes } from "src/constants";
import { CommonFilterProps } from "../CommonFilters";
import { DateFilter } from "./DateFilter";

const STATUS_DATE_FILTER_KEYS = {
  daysAgo: SearchAndFilterTypes.StatusDaysAgo,
  dateFrom: SearchAndFilterTypes.StatusDateFrom,
  dateTo: SearchAndFilterTypes.StatusDateTo,
};

export const StatusDateFilter = (props: CommonFilterProps) => {
  return (
    <DateFilter
      label="Status date"
      description="Filter by date status was changed"
      filterKeys={STATUS_DATE_FILTER_KEYS}
      {...props}
    />
  );
};

const SUB_STATUS_DATE_FILTER_KEYS = {
  daysAgo: SearchAndFilterTypes.SubStatusDaysAgo,
  dateFrom: SearchAndFilterTypes.SubStatusDateFrom,
  dateTo: SearchAndFilterTypes.SubStatusDateTo,
};

export const SubStatusDateFilter = (props: CommonFilterProps) => {
  return (
    <DateFilter
      label="Sub-status date"
      description="Filter by date sub-status was changed"
      filterKeys={SUB_STATUS_DATE_FILTER_KEYS}
      {...props}
    />
  );
};
